export default "__VITE_ASSET__BzJucvIA__"